<template>
    <v-btn-toggle v-model="query['label']" dense color="primary" @change="emit">
        <template v-for="{ text, value } in items">
            <v-btn :key="value" v-bind="{ value }">{{ text }}</v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
let items = [
    { text: "전체", value: null },
    { text: "미디어", value: "미디어" },
    { text: "유튜브", value: "유튜브" },
];

let initQuery = (query = {}) => ({
    ...(query || {}),

    label: query?.label || null,
});

export default {
    components: {},
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query["page"];
            if (!query["label"]) delete query["label"];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
